















































































import { intersection } from 'lodash'
import { blurb } from '@/utilities/audience-helpers.js'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { criteriaOrdering, translateCriteria } from '@/utilities/audience-mappers'
import * as db from '@shared/types/database'

@Component
export default class AudienceInfo extends Vue {
  @Prop({ default: '' }) mode!: string
  @Prop({ default: null }) audience!: db.Audience
  @Prop({ default: '' }) ir!: string
  @Prop({ default: '' }) qtestLink!: string

  reach = false

  get testBuilderMode () {
    return this.mode === 'test-builder'
  }

  get reportMode () {
    return this.mode === 'report'
  }

  get audiencePrefix () {
    switch (this.mode) {
      case 'report':
        return 'Audience Name: '
      case 'test-builder':
        return 'Audience: '
      case 'test-details':
        return ''
    }
  }

  get newAudience () {
    return this.audience && this.audience.title
  }

  get oldAudience () {
    return this.audience && (this.audience.label || this.audience.legacy) && !(this.audience.title === 'US Adults' && this.audience.criteria)
  }

  get customCriteria () {
    if (!this.audience || !this.audience.criteria) return []
    return intersection(['Additional Criteria', 'International'], Object.keys(this.audience.criteria))
  }

  get orderedCriteria () {
    return intersection(criteriaOrdering, Object.keys(this.audience.criteria || {}))
  }

  get translatedCriteria () {
    return translateCriteria(this.audience.criteria || {})
  }

  isCustom (criteria: string) {
    return criteria === 'Additional Criteria'
  }

  customizedClass (criteria: string) {
    // checks if audience has additional criteria or is international
    if (criteria === 'Additional Criteria' || criteria === 'International') {
      return 'custom-criteria'
    }
  }

  display (criteria: string, range: number[]) {
    return criteria === 'Age' ? blurb.displayAge(range) : blurb.displayHHI(range)
  }

  translate (criteria: string, demographic: string) {
    return blurb.displayTextFromPreCodes(criteria, demographic)
  }
}
